module.exports = __webpack_public_path__ + "static/media/woocommerce-connect.de1f2578.svg";